export default __webpack_public_path__ + "static/media/lining20.13159119.jpeg";